import React from 'react';
import { Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import LogoUrl from '../../assets/images/logo-new.jpg';
import LogoUrlDark from '../../assets/images/logo-new-dark.png';
import { useTheme } from '@mui/styles';

interface Props {
	width?: number;
}

export default function Logo({ width = 170 }: Props) {
	const theme = useTheme();
	return (
		<Box
			sx={{
				'& > a': { textDecoration: 'none' },
			}}
		>
			<RouterLink to="/">
				<img
					src={'dark' === theme.palette.mode ? LogoUrlDark : LogoUrl}
					alt={process.env.REACT_APP_TITLE}
					style={{ width, display: 'block' }}
					data-cy="logo"
				/>
			</RouterLink>
		</Box>
	);
}
